import { useMutation } from "react-query";

import { ServiceSupplier } from "doxecure-commons/lib/doxecureTypes";

import { useAuthContext } from "@hooks/useAuthContext";
import { connectUserToDrive } from "@services/drive.service";

export const useConnectToDrive = () => {
    const { connectedProfileId } = useAuthContext();

    return useMutation(({ provider, redirectUri }: { provider: ServiceSupplier; redirectUri: string }) =>
        connectUserToDrive(connectedProfileId, provider, redirectUri)
    );
}